import React, { useEffect, useState } from "react";
import { fetchEntityById } from "../../../apis/apiService";
import { useParams } from "react-router-dom";

const MilestoneStatusTimeline = () => {
  const { id } = useParams();
  const [timeline, setTimeLine] = useState([]);
  const projectStatus = async () => {
    const response = await fetchEntityById("milestones/timeline", id);
    setTimeLine(response.elapsed_time);
    //console.log()(response);
  };
  useEffect(() => {
    projectStatus();
  }, [id]);
  
  return (
    <div className="py-3">
      <div
        className="d-flex justify-content-center align-items-center border  rounded"
        style={{ padding: "84px" }}
      >
        <button className="add_btn">Active</button>

        <div
          className="text-center p-3"
          style={{
            borderBottom: "2px dashed ",
            marginTop: "-55px",
            width: "415px",
          }}
        >
          <span>{timeline ? timeline : "Date is not set"}</span>
        </div>

        <span className="text-rgbr-red">Yet to close</span>
      </div>
    </div>
  );
};

export default MilestoneStatusTimeline;
